import _objectSpread from'@babel/runtime/helpers/objectSpread2';import React from'react';import {P,typography,I}from'@manulife/mux';import styled from'styled-components';import {useIntl}from'react-intl';import Link from'../components/Link/Link.js';import CIAMLink from'../components/CIAMLink/CIAMLink.js';import usePlainTextValues from'./usePlainTextValues.js';function useRichTextValues() {
  var plainTextValues = usePlainTextValues();
  var intl = useIntl();
  var UnorderedList = /*#__PURE__*/styled.ul.withConfig({
    displayName: "useRichTextValues__UnorderedList",
    componentId: "sc-1ypmoui-0"
  })(["margin:0;padding-left:1.25rem;list-style-type:disc;& > li{line-height:1.5rem;margin:0;}"]);
  var OrderedList = /*#__PURE__*/styled.ol.withConfig({
    displayName: "useRichTextValues__OrderedList",
    componentId: "sc-1ypmoui-1"
  })(["margin:0;padding-left:1.25rem;& > li{line-height:24px;margin:0;}"]);
  var ListItem = /*#__PURE__*/styled.li.withConfig({
    displayName: "useRichTextValues__ListItem",
    componentId: "sc-1ypmoui-2"
  })(["margin:0.5rem 0;"]);
  var renderMobileNumber = function renderMobileNumber(chunks) {
    var OFFICE_CODE_START = 3;
    var STATION_CODE_START = 6;
    try {
      var mobileNumber = chunks[0];
      var number = mobileNumber.match(/\d{10}/)[0];
      var areaCode = number.slice(0, OFFICE_CODE_START);
      var officeCode = number.slice(OFFICE_CODE_START, STATION_CODE_START);
      var stationCode = number.slice(STATION_CODE_START);
      return "".concat(areaCode, "-").concat(officeCode, "-").concat(stationCode);
    } catch (_unused) {
      return chunks;
    }
  };
  var richTextValues = _objectSpread({
    p: function p(chunks) {
      return /*#__PURE__*/React.createElement(P, {
        weight: typography.fontWeightLight
      }, chunks);
    },
    i: function i(str) {
      return /*#__PURE__*/React.createElement(I, null, str);
    },
    b: function b(str) {
      return /*#__PURE__*/React.createElement("strong", {
        "data-testid": "strong"
      }, str);
    },
    ul: function ul(chunks) {
      return /*#__PURE__*/React.createElement(UnorderedList, null, chunks);
    },
    ol: function ol(chunks) {
      return /*#__PURE__*/React.createElement(OrderedList, null, chunks);
    },
    li: function li(chunks) {
      return /*#__PURE__*/React.createElement(ListItem, null, chunks);
    },
    sup: function sup(str) {
      return /*#__PURE__*/React.createElement("sup", null, str);
    },
    phone: function phone(number) {
      return /*#__PURE__*/React.createElement(Link, {
        to: "tel:".concat(number)
      }, number);
    },
    email: function email(_email) {
      return /*#__PURE__*/React.createElement(Link, {
        to: "mailto:".concat(_email)
      }, _email);
    },
    ManulifeIdLink: function ManulifeIdLink(chunks) {
      return /*#__PURE__*/React.createElement(CIAMLink, {
        to: "/aboutmanulifeid"
      }, chunks);
    },
    PrivacyPolicyLink: function PrivacyPolicyLink(chunks) {
      return /*#__PURE__*/React.createElement(Link, {
        isExternal: true,
        to: intl.formatMessage({
          id: 'shared.layout.footer.privacy.href'
        })
      }, chunks);
    },
    TermsAndConditions: function TermsAndConditions(chunks) {
      return /*#__PURE__*/React.createElement(Link, {
        isExternal: true,
        to: intl.formatMessage({
          id: 'shared.layout.terms.href'
        })
      }, chunks);
    },
    OnlinePrivacyStatement: function OnlinePrivacyStatement(chunks) {
      return /*#__PURE__*/React.createElement(Link, {
        isExternal: true,
        to: intl.formatMessage({
          id: 'shared.layout.privacystatement.href'
        })
      }, chunks);
    },
    ManulifeIdLinkExternal: function ManulifeIdLinkExternal(chunks) {
      return /*#__PURE__*/React.createElement(Link, {
        isExternal: true,
        to: intl.formatMessage({
          id: '/aboutmanulifeid'
        })
      }, chunks);
    },
    ForgotUsernameLink: function ForgotUsernameLink(chunks) {
      return /*#__PURE__*/React.createElement(CIAMLink, {
        to: "/forgotusername"
      }, chunks);
    },
    ForgotPasswordTryAgainLink: function ForgotPasswordTryAgainLink(chunks) {
      return /*#__PURE__*/React.createElement(CIAMLink, {
        to: "/forgotpassword"
      }, chunks);
    },
    SignInLink: function SignInLink(chunks) {
      return /*#__PURE__*/React.createElement(CIAMLink, {
        to: "/signin"
      }, chunks);
    },
    SignUpLink: function SignUpLink(chunks) {
      return /*#__PURE__*/React.createElement(CIAMLink, {
        to: "/register"
      }, chunks);
    },
    ActivateLink: function ActivateLink(chunks) {
      return /*#__PURE__*/React.createElement(CIAMLink, {
        to: "/activation"
      }, chunks);
    },
    newline: /*#__PURE__*/React.createElement("br", {
      "data-testid": "br"
    }),
    validSpecialCharactersUsername: "#$%+-/=?^_`{|}~;@.",
    validSpecialCharactersPassword: "!\"#$%&()*+-_./:;<=>?@[\\]^{|}",
    mobile: renderMobileNumber
  }, plainTextValues);
  return richTextValues;
}export{useRichTextValues as default};